import { format } from "date-fns";

export async function fetchDateRange(client, url, dateRange) {
    if (
      !dateRange ||
      dateRange.length < 2 ||
      !dateRange.every(x => !!x)
    ) {
      return;
    }

    const rawData = await client(
      url + "?" +
        new URLSearchParams({
          from: format(dateRange[0], "yyyy-MM-dd"),
          until: format(dateRange[1], "yyyy-MM-dd"),
        }),
    );
    const jsonData = await rawData.json();
    return jsonData;
  }
